module.exports = __webpack_public_path__ + "static/img/govcard_05.331ae3f1.svg";